<template>
  <footer class="footer">
    <div class="content has-text-centered">
      <p>
        <strong>iChrispin Diary</strong> by <a href="#">Chrispin</a>. Follow me on:
      </p>
      <p>
        <a href="https://facebook.com" target="_blank"><i class="fab fa-facebook"></i></a>
        <a href="https://twitter.com/iChrispinCoder" target="_blank"><i class="fab fa-twitter"></i></a>
        <a href="https://www.instagram.com/chrispin_chris_?igsh=MXA5cmg4ZDBrMHY2ZQ==" target="_blank"><i class="fab fa-instagram"></i></a>
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterPage'
}
</script>

<style scoped>
.footer {
  padding: 20px;
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: -1;
}
.footer i {
  margin: 0 10px;
  font-size: 1.5rem;
  color: #4a4a4a;
}
.footer i:hover {
  color: #3273dc;
}
</style>
